/**
 /**
 * Extended ViewController template
 *
 * User: adic
 * Date: 5/9/13
 * Time: 3:22 PM
 */


// todo - check the diff: why is this file compared by git with another AgentSurveyWidget file? (e4a14d832c46fb3aa765dcfc85dafa5bc40fd0cf)


define(function (require) {

    window.lpTag = window.lpTag || {};

    var WidgetViewController = require('web-agent-framework/WidgetViewController');
    var AgentSurveyViewController = require('web-agent-viewControllers/AgentSurveyViewController');

    var AgentSurveyWidget = WidgetViewController.extend({
        ControllerName: 'AgentSurveyWidget',
        applicationType: 'AgentActionsWidgetContainer',

        initialize: function (constructorData) {//TODO listen to chatId changes
            this.loading = false;
            this.constructorData = constructorData;
            this.widgetsManager = constructorData.widgetsManager;
            this.hidden = constructorData.hidden || false;
            this.participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            constructorData.templateFile = "LP_agent_survey.html";

        },
        events: function () {
            this.bindModel({
                modelPath: this.participantPath + ".chats",
                callback: this.setChatId
            });
        },
        render: function () {
            this.agentSurvey = new AgentSurveyViewController({
                lazyLoaderAppName: AgentSurveyViewController.applicationType,
                visitorId: this.constructorData.visitorId,
                myChatsOnly: true,
                modelController: this.constructorData.modelController,
                templateFile: "LP_agent_survey.html"
            });
            this.addView({
                targetView: this.view,
                viewToAdd: this.agentSurvey.view
            });
        }
    });


    AgentSurveyWidget.prototype.setChatId = function (data) {
        if (data && data.newValue) {
            var chatIds = Object.keys(data.newValue);
            for (var chat in chatIds) {
                unbindChat.call(this);
                this.chatId = chatIds[chat];
                bindChat.call(this);
            }
        }
        function unbindChat() {
            if (this.chatId) {
                this.unbindModel({
                    modelPath: 'chats.' + this.chatId + '.agentSurvey.active',
                    callback: this.handleSurveyState
                });
            }
        }

        function bindChat() {
            if (this.chatId) {
                this.bindModel({
                    modelPath: 'chats.' + this.chatId + '.agentSurvey.active',
                    callback: this.handleSurveyState
                });
            }
        }
    };
    AgentSurveyWidget.prototype.handleSurveyState = function (data) {
        if (data && data.newValue) {
            this.hidden = !data.newValue;
            this.showWidget();
            if (this.hidden) {
                this.agentSurvey.dispose();
            }
        }
    };

    AgentSurveyWidget.prototype.enableWidget = function (data) {
        if (data.newValue) {
            if (this.widgetsManager.focusedVisitorId === this.visitorId) {
                this.showWidget();
            }
        }
    };

    AgentSurveyWidget.prototype.disableWidget = function (data) {
        if (data.newValue) {
            this.showWidget();
        }
    };

    AgentSurveyWidget.prototype.dispose = function () {
        this.agentSurvey.dispose();
    };

    return AgentSurveyWidget;

});
